import React from 'react';
import { Text } from '@user-portal/wikr-components';

import * as S from '../styled';

import { IAdditionalStatusInfo } from '../../types';

const AdditionalStatusInfo = ({ captions, mb }: IAdditionalStatusInfo) => {
    return (
        <S.AdditionalStatusInfo $mb={mb}>
            {captions?.title && <Text mb={8}>{captions.title}</Text>}
            <Text color="text-secondary">{captions?.description}</Text>
        </S.AdditionalStatusInfo>
    );
};

export default AdditionalStatusInfo;
